export default __webpack_public_path__ + "cb94048bd7846e9847dd184b0c46d642.png";